import { ChangeEvent } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';
import { TextInput } from '../TextInput/TextInput';
import { FormFieldProps, RecommendableFieldProps } from '../interfaces';

const DEFAULT_MIN_DATE = '1915-01-01';
const DEFAULT_MAX_DATE = '2125-12-31';

interface DatePickerProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>
  extends FormFieldProps<TFieldValues, TName>, RecommendableFieldProps {
  minDate?: string;
  maxDate?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const DatePicker = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: DatePickerProps<TFieldValues, TName>
) => {
  const { minDate = DEFAULT_MIN_DATE, maxDate = DEFAULT_MAX_DATE, onChange, ...rest } = props;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    // Native <input type="date"> lets users type 5–6 digit years. Clamp to 4 digits
    // so values stay within a realistic range (also enforced by min/max).
    const match = e.target.value.match(/^(\d+)(-\d{2}-\d{2})$/);
    if (match && match[1].length > 4) {
      e.target.value = match[1].slice(0, 4) + match[2];
    }
    onChange?.(e);
  };

  return <TextInput {...rest} type="date" min={minDate} max={maxDate} onChange={handleChange} />;
};
